'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("natureService", function ($q, $http, $translate) {
  var sousNaturesParNature = {};

  /**
   *
   * @param nature pour laquelle retourner les sous natures
   * @return {*}
   */
  function _getSousNatures(nature) {
    if (!_.isEmpty(sousNaturesParNature)) {
      return $q.resolve(sousNaturesParNature[nature]);
    }
    return $http.get('/rest/lov/sous-natures').then(function (response) {
      sousNaturesParNature = response.data;
      return sousNaturesParNature[nature];
    }).catch(function (e) {
      console.error("impossible de recupérer les sous-natures", e);
      throw e;
    });
  }
  return {
    /**
     *
     * @param nature
     * @return {*} promise
     */
    getSousNatures: function getSousNatures(nature) {
      return _getSousNatures(nature);
    },
    /**
     *
     * @param nature pour laquelle retourner les sous-natures
     * @return {*} promise
     */
    getSousNaturesLov: function getSousNaturesLov(nature) {
      return _getSousNatures(nature).then(function (sousNatures) {
        return _.map(sousNatures, function (sousNature) {
          return {
            id: sousNature,
            label: $translate('nature.' + sousNature)
          };
        });
      });
    },
    getSelectDefautConfig: function getSelectDefautConfig() {
      return {
        optionTemplate: '<div class="report-template-option">' + '<div class="display-ib">' + '<div style="min-width: 4em; display: inline-block; padding-right: 3px">' + '<pill-nature-produit nature=\'{{option.id}}\'></pill-nature-produit>' + '</div>' + ' <span class="label">{{option.label}}</span>' + '</div>'
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/natureService.js
// module id = 2878
// module chunks = 13